<div class="presentation-shell" [ngClass]="{ absolute }">
  <app-presentation-header [isMobile]="isMobile"></app-presentation-header>
  <ng-content></ng-content>
</div>
